import {
  MEMO_FIELD_ORDER,
  toApiPrintStyle,
  toUiPrintStyle,
  getDefaultMemoFieldKeys,
  pickMemoFieldKeys,
} from './stallDotMatrixPrintShared';

/** 从列表/接口 templateBO 初始化编辑页表单 */
export function initDistributionFormState(templateBO) {
  const printStyle = toUiPrintStyle(templateBO?.printStyle);
  let fieldKeys = getDefaultMemoFieldKeys();
  if (Array.isArray(templateBO?.productFieldList)) {
    const allowed = new Set(MEMO_FIELD_ORDER);
    const picked = templateBO.productFieldList.filter((k) => allowed.has(k));
    fieldKeys = pickMemoFieldKeys(picked);
  }
  return { printStyle, fieldKeys };
}

/** 组装配货单保存请求体 */
export function buildNeedleMemoTemplateSaveParams(formState, stallId) {
  return {
    stallId,
    templateBO: {
      printStyle: toApiPrintStyle(formState.printStyle),
      productFieldList: pickMemoFieldKeys(formState.fieldKeys),
    },
  };
}
